/* the kinds of views of batches we support */

export enum BatchView {
  EDIT,
  MONITOR,
  None
}

/** convert batch view kind */
export function stringOfBatchView(type: BatchView) {

  switch (type) {
    case BatchView.EDIT:    return 'edit';
    case BatchView.MONITOR: return 'monitor';
    case BatchView.None:    return 'none';
  }

  return 'none';
}

/** convert to string */
export function batchViewOfString(text: string) {

  text = text.toLowerCase().trim();

  switch (text) {
    case 'edit':    return BatchView.EDIT;
    case 'monitor': return BatchView.MONITOR;
    case 'none':    return BatchView.None;
  }

  return BatchView.None;
}
